import EthIcon from "./eth-icon";

export default EthIcon;
